import {ethers, utils} from 'ethers'

export const validateAddress = (address:string):boolean => {
    // Usa ethers.utils.isAddress per validare l'indirizzo
    const lowerCaseAddress = address.toLowerCase();
    return ethers.utils.isAddress(lowerCaseAddress);
};


